import { motion } from "framer-motion";
import { BarLoader } from "react-spinners";

export const Loading = ({ loading, counter }) => {
  function formatCounter(number) {
    return String(number).padStart(3, "0");
  }

  return (
    <motion.div
      initial={{ scaleX: 1 }}
      animate={{ scaleX: loading ? 1 : 0 }}
      exit={{ scaleX: 1 }}
      transition={{ duration: 1, ease: "circInOut" }}
      style={{ originX: loading ? 0 : 1 }}
      className="privacy-screen"
    >
      {loading ? (
        // Render loading spinner while loading is true
        <div
          className="font-neue"
          style={{
            color: "#000",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <BarLoader height={8} />
          </div>
          <h1 className="position-absolute bottom-0" style={{ fontSize: 120 }}>
            {formatCounter(counter)}
          </h1>
        </div>
      ) : null}
    </motion.div>
  );
};
